import Div from "@jumbo/shared/Div/Div";
import {Box, Paper, Skeleton, Tab, Tabs} from "@mui/material";
import TabPanel from "app/pages/Docgen/components/common/mui-tabpanel/MuiTabpanel";
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {get} from "../../../common/network";
import FormDetailsTab from "./FormDetailsTab";
import ModifyDetails from "./ModifyDetails";
import "./FormDetails.css";


const FormDetails = () => {
  //#region for states
  const [activeTab, setActiveTab] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const formId = queryParams.get("id");
  const [formData, setFormData] = useState([]);
 const [loading,setLoading] = useState(false);

  //#endregion
    const isAdmin = localStorage.getItem("TENANT_ROLE") === "admin";

  //region for the useEffect to fetch the data from the server

  useEffect(() => {
    const fetchData = async () => {
      try{
        setLoading(true);
        const response = await get(`docgen/forms/${formId}`);
        setFormData(response);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [formId]);

  return (
    <div className="page-content-wrapper">
      <Box className="w-100">
        <header className="section-heading">
          <div className="left-area">
            <h2>
              {formData?.data?.form_name ? (
                formData?.data?.form_name
              ) : (
                <Skeleton
                  animation="wave"
                  sx={{ height: "60px", maxWidth: "400px" }}
                />
              )}
            </h2>
          </div>
          <div className="right-area"></div>
        </header>
        <Paper>
          <Div>
            <Tabs
              value={activeTab}
              onChange={(event, newValue) => {
                setActiveTab(newValue);
              }}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
              className="mui-tab-header"
            >
              <Tab label="Form" />
                {isAdmin && formData?.data?.form_type !== "standard" && <Tab label="Modify"/>}
            </Tabs>
              <TabPanel value={activeTab} index={0}>
              <FormDetailsTab formData={formData} />
              </TabPanel>
              {isAdmin && formData?.data?.form_type !== "standard" && <TabPanel value={activeTab} index={1}>
              <ModifyDetails formData={formData} id={formId} loadingFormData={loading}/>
              </TabPanel>}
          </Div>
        </Paper>
      </Box>
    </div>
  );
};

export default FormDetails;